module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Shortcut_16"],"path":[{"$":{"d":"M11,10h2v5H0V2H4V4H2v9h9Zm0-3.85V8.87l4.91-4.36L11,.15V2.87A6.45,6.45,0,0,0,3.91,9.42S5,6.15,11,6.15Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Shortcut_16.svg
// module id = 2aJK
// module chunks = 1